import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../services/mysql.service';

// 
import { Job } from '../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from './../../services/file-uploader-service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { LostPasswordComponent } from './../../views/lost-password/lost-password.component';
// import { PasswordStrengthWidgetComponent } from './password-strength-widget/password-strength-widget.component';
import { UserAvitarModalUploadComponent } from './../../admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
// import { UserPasswordExpiredModalComponent } from '../user-password-expired-modal/user-password-expired-modal.component';
import { HotToastService } from '@ngneat/hot-toast';
import { IdleService } from 'src/app/services/idle.service';
declare var jQuery:any;
// import { DateTime, Settings } from 'luxon'; // new luxon stuff


@Component({
  selector: 'app-system-force-logout-widget',
  templateUrl: './system-force-logout-widget.component.html',
  styleUrls: ['./system-force-logout-widget.component.scss']
})
export class SystemForceLogoutWidgetComponent implements OnInit {

   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'full'; // side | abstract | full
  user_id: any;
  baseUploadURL: string;
  brandMysql: any;
  user_level: any;
  baseBrandUploadURL: string;
  users: any;
  brand_id: any;
  access_level: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  current_base_route: string;
  brand_user: Object;
  force_logout: any;



  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, private toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private idleService: IdleService,
  ) { 

    // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
  }



 // check for changes. to load data.
 ngOnChanges(changes) {

    // Do a little pause to get the status.
    // this.getBrandUser(this.gfunc.sessionUserId)

    if (changes.item_data) {
      // this.getBrandUser(this.sessionUserId);
    }


  if (changes.item_id) {
    // deal with asynchronous Observable result
  //   this.user_id = changes.item_id.currentValue;
  //  //  this.getBrandById(this.brand_id);
  // //  this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing
  //  this.getBrandUser(this.user_id);

       // this.force_logout = 0;





  }
}

  ngOnInit(): void {
    this.getBrandUser(this.sessionUserId);
  }


// Database Functions
// NEED TO INSERT A LOG HERE
getBrandUser(user_id) {
  this._demoService.getBrandUser(user_id).subscribe(
     data => { this.brand_user = data;
    let res = data[0];
    this.force_logout = res.force_logout;

            console.log('FLO:Check:: ' + this.force_logout)
            // ######  FORCE LOGOUT
              // see if I can initiate the timer code I already have.
              if(this.force_logout == 1){
                // if(this.gfunc.sessionUserId == '108'){
                this.idleService.init(5);
                // or kill and go direct and fource this user to logout.
                // this.gfunc.login();
              
              } else{
                this.idleService.init(1200); // in seconds; // 10 mins = 600 seconds at idle
              }


    },
     err => console.error(err),
     () => console.log('done FLO')
   );
 }





}
